module.exports = __webpack_public_path__ + "static/img/gruszka.b73e2dbe.webp";